import { useObservable } from '@lib/common';
import { guestSurveyService } from '@lib/state';
import { SurveyOutreachFilters } from '@lib/state/guest-survey/guest-survey.model';
import { guestSurveyQuery } from '@lib/state/guest-survey/guest-survey.query';
import { useEffect } from 'react';

export function useSearchSurveys(propertyId: string | null, filters: SurveyOutreachFilters) {
  const surveys = useObservable(guestSurveyQuery.guestSurveys);
  const pagination = useObservable(guestSurveyQuery.pagination);
  const loading = useObservable(guestSurveyQuery.loading);

  useEffect(() => {
    if (propertyId && filters) {
      guestSurveyService.getGuestSurveys(propertyId, filters);
    }
  }, [propertyId, filters]);

  return {
    surveys,
    pagination,
    loading,
  };
}
